import React from 'react';

import Actions from './RowActions';

export default [
  {
    name: 'Bill To',
    selector: (row) => row.attributes.name,
    sortable: true,
  },
  {
    name: 'Email',
    selector: (row) => row.attributes.email,
    sortable: true,
  },
  {
    name: 'Address',
    selector: (row) => row.attributes.full_address,
    sortable: true,
  },
  {
    name: 'Payment Method',
    selector: (row) => row.attributes.payment_method,
    sortable: true,
  },
  {
    name: 'Actions',
    sortable: false,
    width: '120px',
    cell: (row) => <Actions row={row} />,
  },
];
